import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SummaryApi from "../../../common";


export default function BankAccountManager() {
  const [accounts, setAccounts] = useState([]);
  const [form, setForm] = useState({
    accountName: "",
    accountNumber: "",
    ifscCode: "",
    accountType: "",
    balance: "",
  });
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showForm, setShowForm] = useState(false);

  const navigate = useNavigate();

  // Fetch all accounts
  const fetchAccounts = async () => {
    try {
      const res = await fetch(SummaryApi.bankAccount.getAll.url);
      const data = await res.json();
      if (res.ok) setAccounts(data.data);
    } catch (error) {
      console.error("Error fetching accounts:", error);
    }
  };

  useEffect(() => {
    fetchAccounts();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

 const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setMessage("");

  // ✅ Get URL & Method from SummaryApi
  const { url, method } = editingId
    ? SummaryApi.bankAccount.update(editingId)
    : SummaryApi.bankAccount.create;

  try {
    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...form,
        balance: parseFloat(form.balance),
      }),
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Something went wrong");

    setMessage(data.message);
    setForm({
      accountName: "",
      accountNumber: "",
      ifscCode: "",
      accountType: "",
      balance: "",
    });
    setEditingId(null);
    setShowForm(false);
    fetchAccounts();
  } catch (error) {
    setMessage(error.message);
  } finally {
    setLoading(false);
  }
};

  const handleEdit = (account) => {
    setForm({
      accountName: account.accountName,
      accountNumber: account.accountNumber,
      ifscCode: account.ifscCode,
      accountType: account.accountType,
      balance: account.balance,
    });
    setEditingId(account._id);
    setShowForm(true);
  };

  return (
    <div className="max-w-6xl mx-auto p-6">
      {/* Header Buttons */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Bank Account Manager</h1>
        <div className="space-x-2">
          <button
            onClick={() => setShowForm(!showForm)}
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Create Bank Account
          </button>
          <button
            onClick={() => navigate("/dashboard/bank-account/transactions")}
            className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
          >
            Account Transactions
          </button>
        </div>
      </div>

      {/* Form */}
      {showForm && (
        <form
          onSubmit={handleSubmit}
          className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-6"
        >
          {message && <p className="mb-4 text-green-600">{message}</p>}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block mb-1 font-semibold">Account Name</label>
              <input
                type="text"
                name="accountName"
                value={form.accountName}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2"
                required
              />
            </div>
            <div>
              <label className="block mb-1 font-semibold">Account Number</label>
              <input
                type="text"
                name="accountNumber"
                value={form.accountNumber}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2"
                required
              />
            </div>
            <div>
              <label className="block mb-1 font-semibold">IFSC Code</label>
              <input
                type="text"
                name="ifscCode"
                value={form.ifscCode}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2"
                required
              />
            </div>
            <div>
              <label className="block mb-1 font-semibold">Account Type</label>
              <input
                type="text"
                name="accountType"
                value={form.accountType}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2"
                required
              />
            </div>
            <div>
              <label className="block mb-1 font-semibold">Balance</label>
              <input
                type="number"
                name="balance"
                value={form.balance}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2"
                min="0"
              />
            </div>
          </div>
          <button
            type="submit"
            className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            disabled={loading}
          >
            {editingId ? "Update Account" : "Create Account"}
          </button>
        </form>
      )}

      {/* Accounts Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {accounts.map((acc) => (
          <div
            key={acc._id}
            className="bg-white shadow rounded p-4 border border-gray-200"
          >
            <h3 className="text-lg font-semibold mb-2">{acc.accountName}</h3>
            <p>
              <span className="font-semibold">Number:</span> {acc.accountNumber}
            </p>
            <p>
              <span className="font-semibold">IFSC:</span> {acc.ifscCode}
            </p>
            <p>
              <span className="font-semibold">Type:</span> {acc.accountType}
            </p>
            <p>
              <span className="font-semibold">Balance:</span> ₹{acc.balance}
            </p>
            <button
              onClick={() => handleEdit(acc)}
              className="mt-2 bg-yellow-400 text-white px-3 py-1 rounded hover:bg-yellow-500"
            >
              Edit
            </button>
          </div>
        ))}
        {accounts.length === 0 && (
          <p className="col-span-3 text-center text-gray-500">
            No accounts found
          </p>
        )}
      </div>
    </div>
  );
}
